import { render, staticRenderFns } from "./CorPadrao.vue?vue&type=template&id=6f2c8e28&scoped=true&"
import script from "./CorPadrao.vue?vue&type=script&setup=true&lang=js&"
export * from "./CorPadrao.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c8e28",
  null
  
)

export default component.exports